"use client";
import Image from "next/image";
import em from "@/assets/images/em.png";
import sca from "@/assets/images/sca.png";
import gforce from "@/assets/images/gforce.png";
import { Unbounded } from "next/font/google";
import { useTranslations } from "next-intl";

const unbounded = Unbounded({ subsets: ["latin"], weight: ["400", "700"] });

export default function Brands() {
  const t = useTranslations("Header");

  return (
    <div className=" container xl:mt-[199px] lg:mt-[60px] mt-[41px] px-4 xl:px-[60px] lg:px-[40px]">
      <div className="xl:pb-[3.875rem] lg:pb-[3.125rem] pb-[2.6875rem] text-center xl:max-w-[43.75rem] mx-auto">
        <div id="brand" className="scroll-mt-40"></div>
        <h1
          className={`${unbounded.className} font-semibold xl:text-5xl lg:text-[2.625rem] text-[2rem] text-center xl:leading-[4.375rem] leading-10`}
        >
          {t("brand_title")}
        </h1>
        <p className="lg:text-[1.25rem] text-base font-medium text-center pt-6">
          {t("brand_text")}
        </p>
      </div>

      {/* Grid system */}
      <div className="grid md:grid-cols-1 xl:grid-cols-2 gap-4">
        {/* Chap tomondagi katta blok */}
        <div className="flex items-center justify-center bg-gradient-to-t from-[#D9D9D9] to-[#F0F2F5] p-4 xl:h-[46.875rem] h-[12.5rem]">
          <a href="https://das-marketing.uz">
            <Image
              src={em}
              alt="em"
              width={500}
              height={180}
              className="object-contain max-w-[31.25rem] w-ful xl:w-[28.125rem] lg:w-[23.75rem] md:w-[18.75rem] w-[13.75rem] h-auto"
              priority
            />
          </a>
        </div>

        {/* Ong tarafdagi ikkita kichik blok */}
        <div className="flex flex-col gap-4">
          <div className="flex items-center justify-center bg-gradient-to-t from-[#D9D9D9] to-[#F0F2F5] p-4 xl:h-[22.9688rem] h-[12.5rem]">
            <a href="https://wmsky.uz">
              <Image
                src={sca}
                alt="sky"
                width={400}
                height={80}
                className="object-contain max-w-[25rem] xl:w-[21.875rem] lg:w-[18.75rem]  w-[14.0625rem]"
                priority
              />
            </a>
          </div>

          <div className="flex items-center justify-center bg-gradient-to-t from-[#D9D9D9] to-[#F0F2F5] p-4 xl:h-[22.9375rem] h-[12.5rem]">
            <a href="https://gforce.uz">
              <Image
                src={gforce}
                alt="gforce"
                width={420}
                height={100}
                className="object-contain max-w-[26.25rem] xl:w-[23.125rem] lg:w-[20.625rem]  w-[12.8125rem]"
                priority
              />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
